// extracted by mini-css-extract-plugin
export default {"page":"AYLnbYNKvxSSN4NlSZiL"};